import React, { useState } from "react";
import { Dialog, DialogTitle, DialogContent, Tabs, Tab, Box, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useIsMobile } from "../hooks/useIsMobile.ts";
import { useSeason } from "../SeasonContext.tsx";
import { regulationFor } from "./Regulation/regulations.ts";
import type { RegulationBlock } from "./Regulation/regulationTypes";

const tabStyles = {
    textTransform: "none",
    fontWeight: "bold",
    fontSize: "0.95rem",
    color: "#555",
    "&.Mui-selected": {
        color: "#1976d2",
        backgroundColor: "#e3f2fd",
        borderRadius: "4px",
    },
    marginRight: 1
};

function Block({ block }: { block: RegulationBlock }) {
    switch (block.type) {
        case "list":
            return (
                <Box component="ul" sx={{ pl: 4, my: 0 }}>
                    {block.items.map((item, i) => (
                        <li key={i}>
                            <Typography variant="body1" textAlign="justify">{item}</Typography>
                        </li>
                    ))}
                </Box>
            );
        case "note":
            return <Typography variant="body1" textAlign="justify" sx={{ fontWeight: 600 }}>{block.text}</Typography>;
        default:
            return <Typography variant="body1" textAlign="justify">{block.text}</Typography>;
    }
}

/** Regolamento del torneo 2.32 relativo alla stagione selezionata (vedi Regulation/regulations.ts) */
export default function RegulationDialog({ open, onClose }) {
    const isMobile = useIsMobile();
    const { selectedSeason } = useSeason();
    const [tab, setTab] = useState(0);

    const regulation = regulationFor(selectedSeason?.code);
    const section = regulation.sections[Math.min(tab, regulation.sections.length - 1)];

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="md" fullScreen={isMobile}>
            <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", backgroundColor: "primary.main" }}>
                {regulation.title}
                <IconButton onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <Tabs value={tab} onChange={(_, v) => setTab(v)} variant="scrollable" scrollButtons allowScrollButtonsMobile>
                {regulation.sections.map((s) => (
                    <Tab key={s.label} label={s.label} sx={tabStyles} />
                ))}
            </Tabs>

            <DialogContent>
                <Box p={2} sx={{ minHeight: { xs: "auto", sm: 450 }, maxHeight: { xs: "none", sm: "60vh" }, overflowY: "auto" }}>
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                        {section.blocks.map((block, i) => (
                            <Block key={i} block={block} />
                        ))}
                    </Box>
                </Box>
            </DialogContent>
        </Dialog>
    );
}
